import React from 'react';
import useError from './useError';
import { Snackbar, IconButton, Slide } from '@material-ui/core';
import { TransitionProps } from '@material-ui/core/transitions/transition';
import { Close } from '@material-ui/icons';
import "./styles.scss";

function SlideTransition(props: TransitionProps) {
    return <Slide {...props} direction="down" />;
  }


const ErrorNotification: React.FC = () => {
  const { error, removeError } = useError();

  const handleClose = () => {
    removeError();
  };

  return (
    <Snackbar
        open={!!error}
        anchorOrigin={{
            vertical: 'top',
            horizontal: 'center'
        }}
        TransitionComponent={SlideTransition}
        message={error}
        autoHideDuration={6000}
        onClose={handleClose}
        className="error-snackbar"
        action={
            <IconButton onClick={handleClose}>
                <Close />
            </IconButton>
        }  
    />
  )
};

export default ErrorNotification;